export default __webpack_public_path__ + "static/media/computadorCafeMobile.19f6c16a.svg";